import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import ProductBundles from '@elem/compCommon/ProductConstructor/Bundles';
import NavProduct from '../comps/NavProduct';
import TabSupport from '../comps/TabSupport';
import TabSpecs from '../comps/TabSpecs';
import HeadDevice from '../comps/HeadDevice';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import ProductContent from './comps/ProductContent';
import styles from './index.module.scss';
import { US_Bundles } from './common';
import TC from './comps/TC';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { useSupportData } from '@/utils/hooks';

const langKey = 'power_kits_48v_system';
const generalKey = 'product_pk_hub_5kva';
const theme = 'white';
const tabList = ['Product', 'Support', 'Specs'];
export default function Detail() {
    const { productTabActive, pageStatus } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { locale, query } = router;
    const tabName: string = (query.tab as string) || '';
    const { gloproductlist } = useGlobal();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg, productMsg?.spuId || productMsg?.sourceId);

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    const bundles = useMemo(() => {
        switch (locale) {
            case 'us':
                return US_Bundles;
            default:
                return US_Bundles;
        }
    }, [locale]);

    return (
        <div className={`${styles.detail} ${pageStatus}`}>
            {locale === 'us' && <HeadDevice />}
            <NavProduct />
            {productTabActive === 'Product' && (
                <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                    <ProductContent />
                </div>
            )}
            {productTabActive === 'Bundles' && locale === 'us' && (
                <>
                    <div className={`product-item-tab product-item-tab-active Bundles`}>
                        <ProductBundles variantImg langKey={langKey} bundles={bundles} />
                    </div>
                    <TC />
                </>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport supportData={supportData} theme={theme} spuId={productMsg?.spuId || productMsg?.sourceId} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                </div>
            )}
        </div>
    );
}
